import React from 'react';
import { Link } from 'react-router-dom';

const LINKS = [
  { to: '/services/ecommerce', label: 'E-commerce solutions' },
  { to: '/services/booking-systems', label: 'Online booking systems' },
  { to: '/services/local-seo', label: 'Local SEO strategy' }
];

export default function LocalAreaSpecialisms() {
  return (
    <aside
      className="mt-10 p-5 rounded-2xl border border-indigo-200/80 bg-gradient-to-br from-indigo-50/90 to-white shadow-sm"
      aria-labelledby="our-specialisms-heading"
    >
      <h3 id="our-specialisms-heading" className="text-lg font-bold text-gray-900 mb-3">
        Our specialisms
      </h3>
      <p className="text-sm text-gray-600 mb-4 leading-relaxed">
        Same South West team: retail e-commerce, tourism booking flows, and local SEO tied to how people search in your postcode.
      </p>
      <ul className="space-y-2">
        {LINKS.map((item) => (
          <li key={item.to}>
            <Link
              to={item.to}
              className="text-indigo-600 font-medium hover:underline text-sm sm:text-base inline-flex items-center gap-1"
            >
              {item.label}
              <span className="text-indigo-400" aria-hidden>
                →
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}
